// Defaults for a newly-added text field.
//
// A new field's position must depend on canvas orientation: one fixed default
// lands in the wrong place on the opposite orientation. Portrait looks want the
// field low-center over the subject; landscape collage looks (e.g. a 3000x2400
// memory-mate) want it on the RIGHT, beside the photo — a portrait default there
// drops the text across the middle of the photo and stretches it full-width.

export const PORTRAIT_TEXT_PLACEMENT = {
  center_x: 0.5,
  center_y: 0.85,
  bound_x_left: 0.04,
  bound_x_right: 0.96,
};

export const LANDSCAPE_TEXT_PLACEMENT = {
  center_x: 0.75,
  center_y: 0.5,
  bound_x_left: 0.55,
  bound_x_right: 0.96,
};

// canvas_width > canvas_height => landscape; square/portrait => portrait.
export function textFieldPlacement(canvasWidth, canvasHeight) {
  return (canvasWidth || 0) > (canvasHeight || 0)
    ? LANDSCAPE_TEXT_PLACEMENT
    : PORTRAIT_TEXT_PLACEMENT;
}

// The full default object for a new text field at `position`, with placement
// chosen for the look's canvas orientation. All non-positional defaults are
// identical across orientations.
export function newTextField(position, canvasWidth, canvasHeight) {
  return {
    position,
    content: '{{first_name}}',
    font_s3_path: 's3://shoobphoto/fonts/',
    font_filename: 'ADAM-CG-PRO.REGULAR.OTF',
    font_color: '#000000',
    font_size_min: 80,
    font_size_max: 160,
    ...textFieldPlacement(canvasWidth, canvasHeight),
    sizing_rule: 'shrink_to_fit',
    align: 'center',
    bold: false,
    italic: false,
    shadow: false,
  };
}
